<template>
    <div class="row empty-basket-container">
        <div class="col-12">
             <div class="empty-basket-wrapper">
                <div class="empty-basket-box">
                    <div class="empty-basket-icon">
                        <span class="png-icon png-icon-icons-glyph--k-my-basket"></span>
                    </div>
                    <h5>{{ $resourceString["backet.EmptyBasket"] }}</h5>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {

}
</script>